export enum RequestItemType {
  business = 'Business',
  partner = 'Partner'
}